import React from 'react';
import MonacoEditor from "@monaco-editor/react";

const Editor = ({ language, theme, code, onChange }) => {
    const handleEditorChange = (value) => {
        onChange(value || "");
    };

    return (
        <div className="editor-container shadow-sm border rounded overflow-hidden">
            <MonacoEditor
                height="80vh"
                width="100%"
                language={language}
                value={code}
                theme={theme}
                onChange={handleEditorChange}
                options={{
                    minimap: { enabled: false },
                    fontSize: 14,
                    scrollBeyondLastLine: false,
                    automaticLayout: true,
                    lineNumbers: "on",
                    roundedSelection: false,
                    padding: { top: 10 }
                }}
            />
        </div>
    );
};

export default Editor;
